import * as common from './common'
import * as product from './product'
import * as productCategory from './productCategory'
import * as notice from './notice'

export default {
  common,
  product,
  productCategory,
  notice,
}
